module.exports = __webpack_public_path__ + "img/Pickup Icon - charcoal.d77dd449.svg";